import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UnmatchedVisitsComponent} from "../unmatched-visits.component";
import {TableModule} from "primeng/table";
import {DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";
import {SharedModule} from "../../shared/shared.module";
import {DockModule} from "primeng/dock";
import {PaginatorModule} from "primeng/paginator";
// import {GMapModule} from 'primeng/gmap'; // Removed in PrimeNG 16
import {DialogModule} from 'primeng/dialog';
import {SidebarModule} from 'primeng/sidebar';
import {CalendarModule} from "primeng/calendar";
import {MultiSelectModule} from "primeng/multiselect";


@NgModule({
  declarations: [
    UnmatchedVisitsComponent,
  ],
  exports: [
    UnmatchedVisitsComponent,
  ],
    imports: [
        CommonModule,
        TableModule,
        DropdownModule,
        FormsModule,
        SharedModule,
        DockModule,
        PaginatorModule,
        DialogModule,
        // GMapModule, // Removed in PrimeNG 16
        SidebarModule,
        CalendarModule,
        MultiSelectModule,
    ]
})
export class UnmatchedVisitModule { }
